import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Themes - Slider
 * Slug: themes_slider
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.themes_slider-layout');

	layouts.forEach((layout) => {
		const prevEl = layout.querySelector(".swiper-nav-prev");
		const nextEl = layout.querySelector(".swiper-nav-next");
		const swiper = new Swiper(layout.querySelector(".swiper-container"), {
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl,
			},
			breakpoints: {
				0: {
					centeredSlides: true,
					slidesPerView: 1.75,
					spaceBetween: 16,
				},
				768: {
					centeredSlides: false,
					slidesPerView: 2.5
				},
				993: {
					slidesPerView: 4
				}
			}
		});
	});
});
